import React, { useEffect } from "react";

import {
  IgListItemButton,
  IgSelect,
  IgTypography,
} from "@intelligems/ig-theme";
import { ChannelType, TrafficConfigFilterType } from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";

interface ChannelProps {
  onClick: (arg1: any, arg2?: any) => void;
  channels: ChannelType[];
  location?: "analytics" | "audience";
}

export const trafficSourceList: { label: string; key: ChannelType }[] = [
  {
    label: "Google",
    key: "Google",
  },
  {
    label: "Facebook",
    key: "Facebook",
  },
  {
    label: "Instagram",
    key: "Instagram",
  },
  {
    label: "TikTok",
    key: "TikTok",
  },
  {
    label: "Twitter",
    key: "Twitter",
  },
];
export const newChannelList: { label: string; key: ChannelType }[] = [
  {
    label: "Direct",
    key: "Direct",
  },
  {
    label: "Email",
    key: "Email",
  },
  {
    label: "Referral",
    key: "Referral",
  },
  {
    label: "Organic Social",
    key: "Organic Social",
  },
  {
    label: "Paid Social",
    key: "Paid Social",
  },
  {
    label: "Organic Search",
    key: "Organic Search",
  },
  {
    label: "Paid Search",
    key: "Paid Search",
  },
  {
    label: "SMS",
    key: "SMS",
  },
  {
    label: "Youtube",
    key: "Youtube",
  },
];

export const channelTypeList: { label: string; key: ChannelType | null }[] = [
  {
    label: "All Sources",
    key: null,
  },
  ...newChannelList,
  ...trafficSourceList,
];

// old channels
// export const analyticsChannelTypeList: { label: string; key: ChannelType }[] = [
//   {
//     label: "All Channels",
//     key: "any",
//   },
//   {
//     label: "Direct",
//     key: "Direct",
//   },
//   {
//     label: "Email",
//     key: "Email",
//   },
//   {
//     label: "Google",
//     key: "Google",
//   },
//   {
//     label: "Meta",
//     key: "Meta",
//   },
//   {
//     label: "Linktree",
//     key: "Link Tree",
//   },
//   {
//     label: "TikTok",
//     key: "TikTok",
//   },
//   {
//     label: "Twitter",
//     key: "Twitter",
//   },
//   {
//     label: "Wunderkind Text",
//     key: "Wunderkind Text",
//   },
//   {
//     label: "Other",
//     key: "Other",
//   },
// ];

export const Channel = ({
  channels,
  onClick,
  location = "analytics",
}: ChannelProps) => {
  const selectedCards = (selectedVisitorType: ChannelType | null): boolean => {
    if (!selectedVisitorType) return channels.length === 0;
    return channels.includes(selectedVisitorType);
  };

  return (
    <Grid container spacing={2} direction={"row"}>
      {channelTypeList.map((channelType) => (
        <Grid item xs={location === "analytics" ? 4 : 2} key={channelType.key}>
          <IgListItemButton
            label={channelType.label}
            onClick={() => {
              onClick(channelType.key || null, "channelType");
            }}
            selected={selectedCards(channelType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

interface ChannelSelectProps {
  onChange: (value: any, changeKey: "key" | "filter" | "value") => void;
  channelType: ChannelType;
}

export const ChannelSelect = ({
  channelType,
  onChange,
}: ChannelSelectProps) => {
  // handle when type switched and value not compatible
  useEffect(() => {
    if (!channelTypeList.find((channel) => channel.key === channelType))
      onChange(channelTypeList[1].key, "value");
  }, []);

  return (
    <Grid item>
      <IgSelect
        variant={"outlined"}
        key={`channel-type`}
        value={channelType || channelTypeList[1].key}
        onChange={(e) => {
          onChange(e.target.value as TrafficConfigFilterType, "value");
        }}
      >
        {channelTypeList
          .filter((channel) => !!channel.key && channel.key !== "Other")
          .map((channel) => (
            <MenuItem key={`${channel.key}`} value={channel.key!}>
              <Grid container direction={"column"}>
                <Grid item>
                  <IgTypography igStyle={"regular"}>
                    {channel.label}
                  </IgTypography>
                </Grid>
              </Grid>
            </MenuItem>
          ))}
      </IgSelect>
    </Grid>
  );
};
